import { inject } from '@angular/core';
import { of, from } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { type CanActivateFn } from '@angular/router';
import { SsoAuthService } from '../services/sso-auth.service';
import { getUrlPathWithParams } from '../../shared/helpers/url.helpers';

export const ssoAuthGuard: CanActivateFn = () => {
  const ssoAuthService = inject(SsoAuthService);

  if (ssoAuthService.hasValidAccessToken()) {
    return of(true);
  }

  return from(ssoAuthService.tryLogin()).pipe(
    map((loggedIn) => {
      if (loggedIn) {
        return true;
      }

      ssoAuthService.startLogin(getUrlPathWithParams());
      return false;
    }),
    catchError((error: unknown) => {
      console.error(error);
      ssoAuthService.startLogin(getUrlPathWithParams());
      return of(false);
    }),
  );
};
